<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Sub Categorias de
          <router-link
            :to="{ name: 'cat-categorias-editar', params: { id: categoria.codigo }}"
          >{{ categoria.codigo }} - {{ categoria.nombre }}</router-link>
        </h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cat-subcategorias-nueva', params: { categoria: categoria.codigo }}"
              >
                <i class="fa fa-plus"></i>
                Nuevo Sub Categoría
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refresh</a>
            </div>
            <div class="col-sm-6">
              <form action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActivo"
                  @click="filterData"
                >
                  <option value="null">Todos</option>
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Nombre de la Sub Categoría</th>
                <th scope="col">Categoría</th>
                <th scope="col" class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td scope="row">{{ current.codigo }}</td>
                <td>{{ current.nombre }}</td>
                <td>{{ current.categoria.nombre }}</td>
                <td class="text-center">
                  <div
                    v-if="current.estatus"
                    class="status-pill green"
                    data-title="Activo"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.estatus"
                    class="status-pill red"
                    data-title="Inactivo"
                    data-toggle="tooltip"
                  ></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import CategoriaService from "@/services/catalogos/CategoriaService";
import SubCategoriaService from "@/services/catalogos/SubCategoriaService";

export default {
  components: {
    PaginationComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: 1,
      categoria: {
        codigo: "",
        nombre: ""
      },
      data: []
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      if (params == undefined) {
        params = {
          categoria: this.$route.params.categoria
        };
      }
      CategoriaService.getById(this.$route.params.categoria).then(response => {
        self.categoria = response.data;
        self.categoria.errors = [];
      });
      SubCategoriaService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-subcategorias-editar",
        params: { categoria: current.categoria.codigo, id: current.codigo }
      });
    },
    showModalEdit() {}
  }
};
</script>
